import * as api from '../api/images';

/** 이미지 관리 서비스 — 업로드 + CRUD */
export const imageService = {
  /** 파일 업로드 → { url } */
  upload: api.uploadImage,
  /** 이미지 메타 등록 (entity_type, entity_id, image_url) */
  create: api.createImage,
  /** 이미지 목록 조회 (관리자, { entity_type, entity_id }) */
  getList: api.getImages,
  /** 이미지 목록 조회 (Public) */
  getPublicList: api.getPublicImages,
  /** 이미지 수정 */
  update: api.updateImage,
  /** 이미지 삭제 */
  delete: api.deleteImage,
};
